export default "__VITE_ASSET__CVAnuUsg__"